// @flow
import * as React from 'react';
import type { Element } from 'react';

import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

import type { Facility } from '@screens/Finder/Doctor/types';

import { DETAILS_DOCTOR } from '@routes';
import { Link, useTranslation } from '@i18n';
import { SVGImageFixedAspectRatio } from '@components/SVG';

import {
  StyledWrapper,
  StyledListItem,
  StyledTextContainer,
  StyledPositionText,
  StyledDepartmentText,
  StyledHospitalText,
  StyledExperienceContainer,
  StyledStartDateText,
  StyledLink,
  StyledIcon,
  StyledImageContainer,
  StyledJobRoleText
} from './styles';

import type { Props } from './types';

const SearchResultListItem = ({
  result, size, bookConsultation = 'show', loadedOnDetails, facilityPage, blogs
}: Props): Element<any> => {
  const { t } = useTranslation('Doctors');

  const doctor = result.attributes;

  const facility: ?Facility = result.relationships?.facility?.data;

  const jobStartDate: string = doctor.practicing_from;

  const placePhotoUrls: string = doctor.image_url;
  const imageAltTag: string = doctor.image_alt_tag;
  return (
    <StyledWrapper size={size} loadedOnDetails={loadedOnDetails} blogs={blogs}>
      <StyledListItem>
        <StyledImageContainer>
          {/* <Link href={DETAILS_DOCTOR} params={{ slug: doctor.slug }} passHref> */}
          {/* <StyledLink Image> */}
          <SVGImageFixedAspectRatio
            imageUrl={
              placePhotoUrls
              || (doctor.gender === 'female'
                ? '/images/finder/female-doctor.png'
                : '/images/finder/doctor.png')
            }
            imageAlt={imageAltTag || ''}
            imageWidth="533"
            imageHeight="540"
          />
          {/* </StyledLink> */}
          {/* </Link> */}
        </StyledImageContainer>

        <StyledTextContainer>
          <StyledPositionText facilityPage={facilityPage}>
            <Link href={DETAILS_DOCTOR} params={{ slug: doctor.slug }} passHref>
              <StyledLink facilityPage={facilityPage} Doctorname>{doctor.name}</StyledLink>
            </Link>
          </StyledPositionText>

          {/* <StyledPositionText>{doctor.job_role}</StyledPositionText> */}
          {facilityPage ? <StyledJobRoleText>{doctor.job_role || '-'}</StyledJobRoleText> : <></>}
          <StyledDepartmentText>{doctor.speciality || '-'}</StyledDepartmentText>

          <StyledHospitalText>{facility?.attributes?.name || '-'}</StyledHospitalText>

          <StyledExperienceContainer>
            {new Date().getFullYear() - new Date(jobStartDate).getFullYear()}
            {' '}
            {t('Experience')}
          </StyledExperienceContainer>
        </StyledTextContainer>
        {
          bookConsultation === 'not-show' ? <></> : (
            <Link href={DETAILS_DOCTOR} params={{ slug: doctor.slug }} passHref>
              <StyledLink startDate>
                <StyledStartDateText>
                  {t('BookConsultation')}
                  <StyledIcon icon={faChevronRight} size="xs" />
                </StyledStartDateText>
              </StyledLink>
            </Link>
          )
        }

      </StyledListItem>
    </StyledWrapper>
  );
};

export default SearchResultListItem;
